import { call, put, takeEvery } from "redux-saga/effects"

import { GET_USER_MENU } from "./actionTypes"

import { getUserMenuFail, getUserMenuSuccess } from "./actions"
import { userAppMenu } from "helpers/backend_helper"

function* fetchUserMenu({ payload }) {
  try {
    const response = yield call(userAppMenu, payload)
    yield put(getUserMenuSuccess(response))
  } catch (error) {
    yield put(getUserMenuFail(error))
  }
}

function* userMenuSaga() {
  yield takeEvery(GET_USER_MENU, fetchUserMenu)
}

export default userMenuSaga
